import { action } from '@ember/object';
import RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type SessionUserService from 'volta/services/session-user';
import { getScrollParent } from 'volta/utils/dom-utils';

interface IArgs {
  enableFullWidth?: boolean;
  fullWidth?: boolean;
}

export default class BvPage extends Component<IArgs> {
  @service router!: RouterService;
  @service sessionUser!: SessionUserService;

  @tracked isHeaderInViewPort: boolean = true;

  headerElement?: HTMLElement;
  headerElementObserver?: IntersectionObserver;

  get fullWidth() {
    return Boolean(
      this.sessionUser.preferences?.pages?.[this.router.currentRouteName]?.fullWidth ??
        this.args.fullWidth ??
        false
    );
  }

  toggleFullWidth = () => {
    this.sessionUser.setPageProperty(this.router.currentRouteName, {
      fullWidth: !this.fullWidth
    });
  };

  @action
  handleHeaderInsert(element: HTMLElement) {
    this.headerElement = element;
    // Get the header parent scrollable element
    const scrollableElement = getScrollParent(element);

    if (scrollableElement) {
      // Whe the header element disappears from the viewport, we want to set property footerSticky to true
      // so the footer will be sticky
      const options = {
        root: scrollableElement
      };
      this.headerElementObserver = new IntersectionObserver((entries) => {
        const [entry] = entries;

        if (entry.isIntersecting) {
          this.isHeaderInViewPort = true;
        } else {
          this.isHeaderInViewPort = false;
        }
      }, options);
      this.headerElementObserver.observe(this.headerElement);
    }
  }

  willDestroy() {
    if (this.isDestroyed || this.isDestroying) {
      return;
    }

    if (this.headerElementObserver) {
      this.headerElementObserver.disconnect();
    }
  }
}
